module.exports = __webpack_public_path__ + "img/ics_o_update_lunas.3f2ab9d3.svg";